import "../assets/css/ForgotPassword.css";
import {
  FORGOT_PASSWORD_ADMIN,
  FORGOT_PASSWORD_MESSAGES,
} from "../utils/forgotPassword";

export default function ForgotPasswordHelpModal({ show, onClose, lang = "en" }) {
  if (!show) return null;

  const t = FORGOT_PASSWORD_MESSAGES[lang] || FORGOT_PASSWORD_MESSAGES.en;
  const { phoneDisplay, phoneTel, email, whatsappUrl, location } =
    FORGOT_PASSWORD_ADMIN;

  return (
    <div
      className="dw-forgot-modal-overlay"
      onClick={onClose}
      role="presentation"
    >
      <div
        className="dw-forgot-modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="dw-forgot-modal-title"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          type="button"
          className="dw-forgot-modal__close"
          onClick={onClose}
          aria-label={t.close}
        >
          ×
        </button>

        <div className="dw-forgot-modal__icon" aria-hidden="true">
          <i className="fa fa-lock" />
        </div>

        <h2 id="dw-forgot-modal-title" className="dw-forgot-modal__title">
          {t.title}
        </h2>
        <p className="dw-forgot-modal__lead">{t.lead}</p>

        <ul className="dw-forgot-modal__contacts">
          <li>
            <a href={`tel:${phoneTel}`}>
              <i className="fa fa-phone" aria-hidden="true" />
              <span>
                <strong>{t.call}</strong>
                {phoneDisplay}
              </span>
            </a>
          </li>
          <li>
            <a href={`mailto:${email}`}>
              <i className="fa fa-envelope-o" aria-hidden="true" />
              <span>
                <strong>{t.email}</strong>
                {email}
              </span>
            </a>
          </li>
          <li>
            <a href={whatsappUrl} target="_blank" rel="noopener noreferrer">
              <i className="fa fa-whatsapp" aria-hidden="true" />
              <span>
                <strong>{t.whatsapp}</strong>
                {phoneDisplay}
              </span>
            </a>
          </li>
        </ul>

        <p className="dw-forgot-modal__location">
          <i className="fa fa-map-marker" aria-hidden="true" /> {location}
        </p>

        <button type="button" className="btn btn-primary" onClick={onClose}>
          {t.close}
        </button>
      </div>
    </div>
  );
}
